import {
  SliderRange,
  SliderRoot,
  SliderThumb,
  SliderTrack,
} from "@jammable/ui-core";
import React, { useState } from "react";
import VoiceImage from "../VoiceImage";

const VolumeSlider = ({ voiceVolume, onValueChange, isDark }) => {
  const [isThumbHovered, setIsThumbHovered] = useState(false);

  return (
    <div className={`tw-pb-2`}>
      <div className="tw-font-semibold tw-mt-1 tw-flex tw-items-center tw-mb-0.5">
        <span className="tw-tracking-tight tw-flex  tw-items-center">
          Vocal Volume
          <div className="tw-flex tw-gap-0.5 tw-ml-2"></div>
        </span>
      </div>

      <SliderRoot
        defaultValue={[0]}
        value={[voiceVolume]}
        min={-12}
        max={12}
        step={2}
        onValueChange={(e) => {
          onValueChange(e[0]);
        }}
        className="tw-w-full  tw-transition-all tw-mt-1.5"
      >
        <SliderTrack
          className={`tw-relative tw-h-5 tw-cursor-pointer tw-transition-all tw-w-full tw-grow tw-overflow-hidden  tw-rounded-lg ${isDark ? " tw-bg-purple-700/40" : "tw-bg-purple-700/10"} `}
        >
          <SliderRange className="tw-absolute tw-h-full tw-bg-transparent tw-transition-all" />
        </SliderTrack>

        <SliderThumb
          className="tw-flex tw-h-7 tw-w-5 tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-md tw-border tw-border-purple-700/50 tw-bg-purple-700 tw-shadow-xl tw-transition-all focus-visible:tw-outline-none focus-visible:tw-ring-1 hover:tw-scale-110 focus-visible:tw-ring-ring disabled:tw-pointer-events-none disabled:tw-opacity-50"
          onMouseEnter={() => setIsThumbHovered(true)}
          onMouseLeave={() => setIsThumbHovered(false)}
        ></SliderThumb>
      </SliderRoot>
    </div>
  );
};

export default VolumeSlider;
